<style lang="less" scoped>
.orderDetails {
  width: 100%;
  background-color: #f0f2f6;
  text-align: left;
  .title {
    width: 100%;
    background-color: #fff;
    padding: 10px 30px;
    padding-bottom: 30px;
    box-sizing: border-box;
    margin-top: 20px;
    font-size: 28px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    overflow: hidden;
    .item {
      width: 100%;
      line-height: 58px;
      color: rgba(51, 51, 51, 1);
      span {
        color: #999999;
      }
      div {
        width: 75%;
        margin: 0 auto;
        margin-top: 15px;
        overflow: hidden;
        img:first-child {
          float: left;
          width: 250px;
          height: 171px;
          background-color: #edf0f4;
        }
        img:last-child {
          float: right;
          width: 250px;
          height: 171px;
          background-color: #edf0f4;
        }
      }
    }
    .span {
      float: left;
      width: 145px;
      line-height: 56px;
      color: #333333;
    }
    .right {
      float: left;
      width: 70%;
      font-size: 28px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      div {
        width: 100%;
        color: #999999;
        line-height: 56px;
      }
    }
  }
  .text {
    width: 100%;
    line-height: 64px;
    font-size: 32px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    margin-bottom: 15px;
    span {
      display: inline-block;
      width: 8px;
      height: 38px;
      background: rgba(33, 170, 255, 1);
      border-radius: 4px;
      vertical-align: middle;
      margin-right: 10px;
    }
  }
  .bottom {
    width: 100%;
    background-color: #fff;
    padding: 30px;
    box-sizing: border-box;
    margin-top: 20px;
    overflow: hidden;
    text-align: center;
    .pass {
      color: #fff;
      background-color: #409eff;
      border-color: #409eff;
      display: inline-block;
      line-height: 1;
      white-space: nowrap;
      cursor: pointer;
      -webkit-appearance: none;
      text-align: center;
      box-sizing: border-box;
      outline: none;
      margin: 0;
      transition: 0.1s;
      font-weight: 500;
      -moz-user-select: none;
      -webkit-user-select: none;
      -ms-user-select: none;
      padding: 12px 20px;
      font-size: 14px;
      border-radius: 4px;
    }
    .reject {
      color: #fff;
      background-color: #f56c6c;
      border-color: #f56c6c;
      display: inline-block;
      line-height: 1;
      white-space: nowrap;
      cursor: pointer;
      -webkit-appearance: none;
      text-align: center;
      box-sizing: border-box;
      outline: none;
      margin: 0;
      transition: 0.1s;
      font-weight: 500;
      -moz-user-select: none;
      -webkit-user-select: none;
      -ms-user-select: none;
      padding: 12px 20px;
      font-size: 14px;
      border-radius: 4px;
    }
    .zhanwei {
      display: inline-block;
      width: 80px;
    }
  }
  .reject_input {
      width: 90%;
      margin: 0 auto;
      min-height: 120px;
      padding: 5px;
      box-sizing: border-box;
      border: 1px solid #eee;
      textarea {
          display: inline-block;
          width: 100%;
          min-height: 120px;
      }
  }
}
</style>

<template>
  <div class="orderDetails">
    <div class="title">
      <div class="text">
        <span></span>订单信息
      </div>
      <div class="item">
        订单编号：
        <span>{{orderItem.id}}</span>
      </div>
      <div class="item">
        订单状态：
        <span>{{orderItem.status_name}}</span>
      </div>
      <div class="item">
        创建时间：
        <span>{{orderItem.created_at}}</span>
      </div>
    </div>
    <div class="title">
      <div class="text">
        <span></span>公司信息
      </div>
      <span class="span">公司名称：</span>
      <div class="right">
        <!-- <div>{{bminfoItem.company_names}}</div> -->
        <div v-for="(list,index) in bminfoItem.company_names" :key="index">{{list}}</div>
      </div>
    </div>
    <div class="title">
      <div class="text">
        <span></span>个人信息
      </div>
      <div class="item">
        姓名：
        <span>{{bminfoItem.legal_name}}</span>
      </div>
      <div class="item">
        联系方式：
        <span>{{bminfoItem.legal_mobile}}</span>
      </div>
      <div class="item">
        身份证号：
        <span>{{bminfoItem.legal_idno}}</span>
      </div>
      <div class="item">
        个人身份证：
        <div>
          <img :src="bminfoItem.idcard_front" alt @click="topic_preview(bminfoItem.idcard_front)" />
          <img :src="bminfoItem.idcard_back" alt @click="topic_preview(bminfoItem.idcard_back)" />
        </div>
      </div>
    </div>
    <div class="title">
      <div class="text">
        <span></span>银行卡信息
      </div>
      <div class="item">
        开户行：
        <span>{{bminfoItem.bank_name}}</span>
      </div>
      <div class="item">
        银行卡号：
        <span>{{bminfoItem.bank_no}}</span>
      </div>
      <div class="item">
        银行预留手机号：
        <span>{{bminfoItem.bank_mobile}}</span>
      </div>
      <div class="item">
        银行卡照片：
        <div>
          <img :src="bminfoItem.bank_back" alt @click="topic_preview(bminfoItem.bank_back)" />
          <img :src="bminfoItem.bank_front" alt @click="topic_preview(bminfoItem.bank_front)" />
        </div>
      </div>
    </div>
    <div class="title">
      <!-- <div class="text">
        <span></span>驳回详情
      </div>
      <div class="item">
        <div class="reject_input">
          <textarea rows="3" cols="20" v-model="value1"></textarea>
        </div>
      </div> -->
    </div>
    <!-- <div class="bottom" v-if="detailsType == 1 && orderItem.auditStatus != 1" :style="isIphoneX ? 'margin-bottom: 68px' : ''">
      <div class="reject" @click="redact">编辑</div>
    </div>
    <div class="bottom" v-if="detailsType == 2" :style="isIphoneX ? 'margin-bottom: 68px' : ''">
      <div class="reject" @click="handleClose1(2)">驳回</div>
      <div class="zhanwei"></div>
      <div class="pass" @click="handleClose1(1)">通过</div>
    </div> -->
    <!-- <i-modal title="驳回详情" :visible="visible1" @ok="rejectedClose" @cancel="rejectedClose">
        <div class="reject_input">
            <textarea rows="3" cols="20" v-model="value1"></textarea>
        </div>
    </i-modal> -->
  </div>
</template>

<script>
import http from '../../api/index.js'
import config from "../../utils/config.js";

export default {
  data() {
    return {
      // visible1: false,
      value1: '',
      orderItem: {},
      bminfoItem: {},
      detailsType: null,
      isIphoneX: false
    };
  },
  mounted() {
    let that = this;
    // wx.getSystemInfo({
    //     success (res) {
    //         let modelmes = res.model;
    //         if (modelmes.search('iPhone X') != -1) {
    //           that.isIphoneX = true
    //         }
    //     }
    // })
    // this.visible1 = false
    console.log(this.$route.query.item)
    var id = JSON.parse(this.$route.query.item).id
    this.queryOrderInfoPost(id)
    this.detailsType = sessionStorage.getItem('detailsType')
    console.log(this.detailsType)
  },
  methods: {
    // redact() {
    //   wx.setStorage({
    //       key:"orderItem",
    //       data: this.orderItem
    //   });
    //   const url = '../legalPerson/main'
    //   this.$router.push({ path: url });
    // },
    queryOrderInfoPost(id) {
        http.post(config.queryOrderInfo,{
            id: id,
        }).then( (e) => {
            console.log(e)
            if (e.code == 1) {
              this.orderItem = e.data;
              this.bminfoItem = e.data.bminfo;
              if(this.bminfoItem) {
                  // order.bminfo.company_names = (order.bminfo.company_names || "").split("#com#").join("、");
                  // this.bminfoItem.company_names = (this.bminfoItem.company_names || "").split("#com#");
                  this.bminfoItem.company_names = this.bminfoItem.company_names ? this.bminfoItem.company_names.split("#com#") : '';
              }
              // this.orderItem = e.orderInfo.child
              // this.orderItem.companyNamesArr = e.orderInfo.child.company_names.split('#com#')
              // this.orderItem.type = e.orderInfo.statusName
              // this.orderItem.id2 =  e.orderInfo.id
              // this.orderItem.id =  e.orderInfo.orderNo
              // this.orderItem.created =  e.orderInfo.created_at
              // this.orderItem.auditStatus = e.orderInfo.auditStatus
            }
        })
    },
    // handleOpen1 () {
    //    this.visible1 = true
    // },
    // rejectedClose(e) {
    //   console.log(e.type)
    //   if (e.type == 'ok') {
    //     console.log('通过222222222')
    //     this.handleClose1(2)
    //   }else {
    //     console.log('取消1')
    //     this.visible1 = false
    //     this.value1 = ''
    //   }
    // },
    handleClose1 (type) {
      console.log(this.value1, this.orderItem, '----------------')

      http.post(config.audit,{
          rejectReason: this.value1,
          auditStatus: type,
          id: this.orderItem.id2
      }).then( (e) => {
          console.log(e)
          if (e.code == 1) {
            this.value1 = ''
            wx.setStorage({
                key:"detailsType",
                data: 2
            });
            const url = '../orderList/main'
            this.$router.push({ path: url });
          }
      })
    },
    topic_preview(url) {
      if (!url || url == '') {
        return
      }

      this.$dialog({
        type: "image", //设置弹窗类型为”图片弹窗“
        link: "", //点击图片跳转的Url
        imgSrc: url, //图片Url
        onClickImageLink:function(){ //图片点击事件，默认行为是跳转Url
          console.log(this); //this指向该Dialog实例
          return false;  //返回false可阻止默认的链接跳转行为
        }
      });
    }
  },
  components: {}
};
</script>


// WEBPACK FOOTER //
// src/pages/orderDetails/index.vue